import styled from 'styled-components';

export const Fake = styled.div`
  @keyframes loader {
    0% {
        background-color: rgba(165, 165, 165, 0.1);
    }
    50% {
        background-color: rgba(165, 165, 165, 0.3);
    }
    100% {
        background-color: rgba(165, 165, 165, 0.1);
    }
}

  @-webkit-keyframes loader {
      0% {
          background-color: rgba(165, 165, 165, 0.1);
      }
      50% {
          background-color: rgba(165, 165, 165, 0.3);
      }
      100% {
          background-color: rgba(165, 165, 165, 0.1);
      }
  };

  background-color: #ddd;
  height: ${props => props.height ? `${props.height}px` : '20px'};
  flex: ${props => props.fillContent ? 1 : 'unset'};
  animation: loader 1.5s infinite ease-in-out;
`;

export const PageArea = styled.div `
  display: flex;
  margin-top: 20px;

  .leftSide {
    width: 250px;
    margin-right: 10px;

    .filterName {
      font-size: 15px;
      margin: 10px 0;
    };

    input, select {
      width: 100%;
      height: 40px;
      border: 2px solid #9bb83c;
      border-radius: 5px;
      outline: 0;
      font-size: 15px;
      color: #000;
      padding: 10px;
    };

    select {
      cursor: pointer;
      background-color: #fff;
    };

    ul, li {
      margin: 0;
      padding: 0;
      list-style: none;
    };

    .categoryItem {
      display: flex;
      align-items: center;
      padding: 12px 15px;
      border-radius: 8px;
      color: #333;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
      margin: 8px 0;
      font-weight: 500;
      border-left: 4px solid transparent;

      i {
        font-size: 18px;
        margin-right: 10px;
        color: #9bb83c;
        transition: all 0.3s ease-in-out;
      };

      img {
        width: 25px;
        height: 25px;
        margin-right: 5px;
      };

      span {
        font-size: 14px;
        transition: color 0.3s ease-in-out;
      };

      &:hover {
        background-color: #f0f0f0;
        border-left-color: #9bb83c;
        transform: translateX(5px);
      };

      &:hover i {
        color: #7a9a2b;
        transform: scale(1.15);
      };
    };

    .categoryItem.active {
      background-color: #9bb83c;
      color: #fff;
      border-left-color: #7a9a2b;

      i {
        color: #fff;
      };

      span {
        color: #fff;
      };
    };
  };

  .rightSide {
    flex: 1;

    h2 {
      margin: 0 10px;
      font-size: 18px;
    };

    .listWarning {
      padding: 30px;
      padding-top: 0;
      text-align: center;
    };

    .list {
      display: flex;
      flex-flow: wrap;
      opacity: ${props => props.resultOpacity};

      & > * {
        width: 25%;
        flex: 0 0 25%;
        max-width: 25%;
      };
    };

    .pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px 0;

      .pagItem {
        width: 30px;
        height: 30px;
        color: #6e0ad6;
        background-color: #fff;
        border: 1px solid #dee2e6;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin: 2.5px;
        cursor: pointer;
        user-select: none;
        transition: all 0.2s ease-in-out 0s;

        &:hover,
        &.active {
          color: #0056b3;
          background-color: #e9ecef;
          border-color: #999;
        };

        &.lastPage {
          opacity: ${props => props.lastPageDisplay ? 1 : 0};
          cursor: ${props => props.lastPageDisplay ? 'pointer' : 'default'};
        };

        &.nextPage {
          opacity: ${props => props.nextPageDisplay ? 1 : 0};
          cursor: ${props => props.nextPageDisplay ? 'pointer' : 'default'};
        };
      };
    };
  };

  @media(max-width: 900px) {
    .leftSide {
      width: 200px;
    }

    .rightSide {
      .list > * {
        width: 33.333%;
        flex: 0 0 33.333%;
        max-width: 33.333%;
      };
    };
  }

  @media(max-width: 768px) {
    flex-direction: column;

    .leftSide {
      width: 100%;
      margin-right: 0;
      margin-bottom: 20px;
      padding: 0 10px;

      ul {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
      };
    };

    .rightSide {
      padding: 0 10px;

      .list > * {
        width: 50%;
        flex: 0 0 50%;
        max-width: 50%;
      };
    };
  }

  @media(max-width: 480px) {
    .rightSide {
      .list > * {
        width: 100%;
        flex: 0 0 100%;
        max-width: 100%;
      };
    };
  };
`;